import { getNewsMediaPulseTracker } from "..";

const trackPageLeave = () => {
  const newsMediaPulseTracker = getNewsMediaPulseTracker();

  newsMediaPulseTracker?.pulseTracker.trackPageLeave();
};

export { trackPageLeave };
